import { Color } from '@gousto-internal/citrus-react'
import type { DiscountBox } from '@library/landing-pages'

export const CONTROL_PROMO_CODE = 'GB-SEABRST5040'
export const TAPERED_PROMO_CODE = 'PPC-DISC-50402010'

export const DEFAULT_BOXES: DiscountBox[] = [
  {
    discountValue: '50%',
    discountSuffix: 'OFF',
    label: '1st box',
    bgColor: Color.Primary_600,
    textColor: Color.White,
  },
  {
    discountValue: '40%',
    discountSuffix: 'OFF',
    label: '2nd box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '20%',
    discountSuffix: 'OFF',
    label: '3rd-8th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
]

export const TAPERED_DISCOUNT_BOXES: DiscountBox[] = [
  {
    discountValue: '50%',
    discountSuffix: 'OFF',
    label: '1st box',
    bgColor: Color.Primary_600,
    textColor: Color.White,
  },
  {
    discountValue: '40%',
    discountSuffix: 'OFF',
    label: '2nd box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '20%',
    discountSuffix: 'OFF',
    label: '3rd-4th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
  {
    discountValue: '10%',
    discountSuffix: 'OFF',
    label: '5th-8th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
]
